import React from 'react';
import { SparkleIcon } from '../../components/SparkleIcon';
import { Box } from '@wix/design-system';

export function LaunchStorePreview() {
  return (
    <Box direction="vertical" align="center" verticalAlign="middle" height="100%" width="100%" gap={2}>
      <SparkleIcon size={120} />
    </Box>
  );
}
